import { api } from "@/lib/api";
import { createAdjustment, type AppointmentAdjustment } from "@/lib/appointment-adjustment";
import { createAppointmentChange, type AppointmentChanges } from "@/lib/appointment-change";
import type { uuid } from "@/interfaces";
import { toAppointmentJoin } from "@/repositories/appointment-records";
import { activeOrganization, type AppointmentJoin } from "@/repositories/appointments.repository";

const change = createAppointmentChange(api.appointments);

const adjust = createAdjustment(api.appointments);

async function changeAppointment(id: uuid, changes: AppointmentChanges): Promise<AppointmentJoin> {
  return toAppointmentJoin(await change(id, changes, activeOrganization()));
}

export const changeScheduledDate = (id: uuid, date: string) => changeAppointment(id, { date });

export const changeService = (id: uuid, service: uuid) => changeAppointment(id, { service });

export const changeWorkOrderNotes = (id: uuid, workOrderNotes: string) => changeAppointment(id, { workOrderNotes });

export async function adjustAppointment(id: uuid, adjustment: AppointmentAdjustment): Promise<AppointmentJoin> {
  return toAppointmentJoin(await adjust(id, adjustment, activeOrganization()));
}
